import produce from "immer";

import types from "./types";

const INITIAL_STATE = {
  behavior: "create",
  components: {
    drawer: false,
    drawer_carros:false,
    drawer_admin:false,
    confirmDelete: false,
    header:false,
  },
  form: {
    filtering: false,
    disabled: true,
    saving: false,
    errorTag: "",
    fail: false,
    steps: 1,
    saveDataForm: false,
    decode: "",
    messageError: "",
    type: "",
  },
  step1: {
    email: "",
    name: "",
    phone_number: "",
  },
  code: {
    id: "",
  },
  auth: {
    id: "",
  },
  codeOk: { id: false },

  step2: {
    id: null,
    cpf: "",
    address: "",
    address_number: "",
    address_complement: "",
    address_district: "",
    address_city: "",
    address_state: "",
    address_zipcode: "",
    password: "",
  }
,
checkOutBase:{
  id_cliente:null,
  start_odometer: null,
  extinguisher: false,
  car_jack:false,
  triangle: false,
  tire_iron:false,
  structure:false,
  painting:false,
  steppe:false,
  document:false,
  reservations_detailscol:"",
  photos:[]
}
,
adminDrawer:[],
  administrador: {
    id: null,
    name: "",
    email: "",
    cpf: "",
    phone_number: "",
    address: "",
    address_number: "",
    address_complement: "",
    address_district: "",
    address_city: "",
    address_state: "",
    address_zipcode: "",
    password: "",
    active: false,
  },
  carro:[],
  carroAdm: {
    id: null,
    license: "",
    model: "",
    odometer: "",
    consumption: "",
    photo: null,
    active: false,
    brands_id: "",
    status: "",
  },
  carrosDisponivel: [],
  reservaCarrosCliente: [],
  carros_liverados: [],
  carros_Alugados: [],
  carro_Alugado: {},
  reservations: [],
  extraTimeVans:[],
  extraTime:{}
};
function admin(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.UPDATE_ADMIN: {
      return produce(state, (draft) => {
        draft = { ...draft, ...action.payload };
        return draft;
      });
    }
    case types.RESET_ADMINS: {
      return produce(state, (draft) => {
        draft.cliente = INITIAL_STATE.cliente;
        return draft;
      });
    }

    default:
      return state;
  }
}

export default admin;
